import React, {PureComponent} from "react"
import gql from "graphql-tag"
import {Query, QueryProps, QueryResult} from "react-apollo"

import {pagination} from "@irati/utils/services/apollo"
import partialUser from "@irati/identity/services/fragments/PartialUser"
import {AccountVoteList} from "@irati/types"

import PollFragment from "../fragments/Poll"

const query = gql`
  query AccountVotes($limit: Int, $cursor: String, $to: String, $from: String) {
    accountVotes(limit: $limit, cursor: $cursor, to: $to, from: $from) {
      results {
        uuid
        createdById
        createdBy {
          ...partialUser
        }
        message
        moderated
        userId
        user {
          ...partialUser
        }
        poll {
          ...Poll
        }
        createdAt
        updatedAt
        moderated
      }
      count
      cursor
    }
  }

  ${partialUser}
  ${PollFragment}
`

export interface VotesVariables {
  from?: string
  limit: number
  to?: string
}

export interface VotesData {
  data: {
    accountVotes: AccountVoteList[]
  }
}

interface Props extends Partial<QueryProps> {
  variables: VotesVariables
  children: any
}

interface CustomQueryResult extends QueryResult {
  // custom children function
  fetchMore: any
}

class TypedQuery extends Query<VotesData, VotesVariables> {}

const variables = {
  limit: 5,
  to: undefined,
  from: undefined
}

export const votesQuery = {
  query,
  variables
}

export default class VotesQuery extends PureComponent<Props> {
  static defaultProps = {
    notifyOnNetworkStatusChange: true,
    useError: false,
    useLoader: false,
    variables
  }

  render() {
    const {children} = this.props
    return (
      <Query {...this.props} query={query} QueryComponent={TypedQuery}>
        {(apolloState: CustomQueryResult) => {
          const fetchMore = (vars: VotesVariables) =>
            pagination(
              {
                ...votesQuery,
                variables: vars
              },
              apolloState
            )
          if (children) {
            return children({...apolloState, fetchMore})
          }
        }}
      </Query>
    )
  }
}
